import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log(`vendor/detail/${obj.vendor_id}`);
                const {
                    data
                } = await axios.get(`vendor/detail/${obj.vendor_id}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'vendor_code', 'vendor_name', 'vendor_address1', 'vendor_city', 'bussinesgroup', 'contact'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/vendor${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'vendor_code', 'vendor_name', 'vendor_address1', 'vendor_city', 'bussinesgroup', 'contact'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/vendor/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Vendor_supplier_List.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/vendor/${obj.vendor_id}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post('/vendor', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    taxgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/vendor/taxgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
};